import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlanDto, PlanPriceDto } from '../../models/plan.model';

@Component({
  selector: 'app-plan-upgrade-confirm-dialog',
  templateUrl: './plan-upgrade-confirm-dialog.component.html',
  styleUrls: ['./plan-upgrade-confirm-dialog.component.scss'],
  standalone: false
})
export class PlanUpgradeConfirmDialogComponent {
  @Input() plan: PlanDto | null = null;
  @Input() price: PlanPriceDto | null = null;
  @Input() isBusy = false;

  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
}
